import { loadStripe } from '@stripe/stripe-js';

// Configuration Stripe
// La clé publique Stripe (publishable key) - peut être exposée côté client
// La clé est définie dans le fichier .env via REACT_APP_STRIPE_PUBLISHABLE_KEY
// Fallback avec la clé de production (pk_live_...) si .env n'est pas chargé
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_live_51RA7Ch07wY37WSDAYMqSkNtBPr7bJY8BoL07LMVmRIq1ibAoN5zU6mrV4sh04buJuZlqP63mHP7dr3QEdMilT2Jy004MgB25ue';

// Initialiser Stripe
export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

// Configuration pour l'escrow
export const STRIPE_CONFIG = {
  // Devise par défaut
  currency: 'eur',
  
  // Pays autorisés
  allowedCountries: ['FR', 'BE', 'CH', 'LU'],
  
  // Méthodes de paiement autorisées
  paymentMethods: {
    card: true,
    sepa_debit: true, // Pour les paiements européens
    ideal: false,     // Pour les Pays-Bas
    bancontact: false, // Pour la Belgique
  },
  
  // Configuration escrow
  escrow: {
    // Délai de libération automatique (en jours)
    autoReleaseDays: 7,
    
    // Commission plateforme (en %)
    platformFeePercent: 2.9,
    
    // Frais fixes (en centimes)
    fixedFeeCents: 30,
  }
};

// Types pour TypeScript
export interface StripePaymentIntent {
  id: string;
  amount: number;
  currency: string;
  status: 'requires_payment_method' | 'requires_confirmation' | 'requires_action' | 'processing' | 'requires_capture' | 'canceled' | 'succeeded';
  client_secret: string;
  metadata: {
    bookingId: string;
    ownerId: string;
    renterId: string;
    dressTitle: string;
  };
}

export interface EscrowPaymentData {
  bookingId: string;
  ownerId: string;
  renterId: string;
  dressTitle: string;
  totalAmount: number;
  ownerAmount: number;
  renterRefund: number;
  currency: string;
}
